// extracted by mini-css-extract-plugin
export default {"terms-text":"FormCadastro_terms-text__rgDO-","content_form":"FormCadastro_content_form__YmOzB","formGroup":"FormCadastro_formGroup__92swY"};